export default function PageLoader({ className = '' }: { className?: string }) {
  return (
    <div className={`next-pageload ${className}`}>
      <div className="next-pageload-inner">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    </div>
  )
}